(() => {
  const root = document.querySelector('[data-product-finder]')
  if (!root) return

  const makeSelect = root.querySelector('#vehicle')
  const modelSelect = root.querySelector('#vehicle_model')
  const messageEl = root.querySelector('[data-finder-message]')
  const dataEl = root.querySelector('[data-finder-data]')
  const productEl = root.querySelector('[data-product-key]')

  if (!makeSelect || !modelSelect || !messageEl || !dataEl || !productEl) return

  const lang = (document.documentElement.getAttribute('lang') || 'de').toLowerCase()
  const isEN = lang.startsWith('en')

  const t = isEN
    ? {
        makeLabel: 'Select brand…',
        modelLabelFirst: 'Select brand first',
        modelLabel: 'Select model…',
        selectPrompt: 'Please select a brand and model.',
        keyMissing: 'Product could not be mapped uniquely. Please set the Finder Key in the product/variant metafield.',
        ok: (make, model) => `Compatible with your ${make} | ${model}`,
        bad: (make, model) => `Not compatible with your ${make} | ${model}`
      }
    : {
        makeLabel: 'Marke wählen…',
        modelLabelFirst: 'Erst Automarke wählen',
        modelLabel: 'Modell wählen…',
        selectPrompt: 'Bitte Automarke und Modell auswählen.',
        keyMissing: 'Produkt konnte nicht eindeutig zugeordnet werden. Bitte Finder-Key im Produkt-/Variantenmetafield setzen.',
        ok: (make, model) => `Kompatibel mit deinem ${make} | ${model}`,
        bad: (make, model) => `Nicht kompatibel mit deinem ${make} | ${model}`
      }

  const safeParse = (raw, fallback) => {
    const s = String(raw || '').trim()
    if (!s || s === 'undefined' || s === 'null') return fallback
    try {
      return JSON.parse(s)
    } catch (e) {
      return fallback
    }
  }

  const db = safeParse(dataEl.textContent, {})
  const product = safeParse(productEl.textContent, {})

  const normalize = (s) => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim()

  const inferKeyFromTitle = (title) => {
    const tt = normalize(title)
    if (tt.includes('c-box one') && tt.includes('1 person')) return 'cbox_one_premium_1p'
    if (tt.includes('c-box one') && (tt.includes('2 personen') || tt.includes('2 personen'))) return 'cbox_one_premium_2p'
    if (tt.includes('c-box one') && tt.includes('split')) return 'cbox_one_premium_split'
    if (tt.includes('c-box two') && tt.includes('115')) return 'cbox_two_premium_115'
    if (tt.includes('c-box two') && tt.includes('120')) return 'cbox_two_premium_120'
    if (tt.includes('v-klasse') || tt.includes('v klasse')) return 'cbox_two_premium_v_klasse'
    return ''
  }

  const getSelectedVariantId = () => {
    const el = document.querySelector('input[name="id"]:checked') || document.querySelector('input[name="id"]')
    return el ? String(el.value) : ''
  }

  const getProductKey = () => {
    const variantId = getSelectedVariantId()
    const variantKey = variantId && product.variant_keys ? product.variant_keys[variantId] : ''
    if (variantKey && variantKey.length) return variantKey

    const productKey = product.finder_key && product.finder_key.length ? product.finder_key : ''
    if (productKey) return productKey

    const title = product.product_title || document.title
    return inferKeyFromTitle(title)
  }

  const setOptions = (select, options, placeholder) => {
    select.innerHTML = ''
    const ph = document.createElement('option')
    ph.value = ''
    ph.textContent = placeholder
    ph.disabled = true
    ph.selected = true
    select.appendChild(ph)

    options.forEach((opt) => {
      const o = document.createElement('option')
      o.value = opt
      o.textContent = opt
      select.appendChild(o)
    })
  }

  const setMessage = ({ ok, make, model, mode }) => {
    messageEl.classList.remove('is-ok', 'is-bad')

    if (mode === 'hide') {
      messageEl.classList.add('is-hidden')
      messageEl.textContent = ''
      return
    }

    messageEl.classList.remove('is-hidden')
    messageEl.classList.add(ok ? 'is-ok' : 'is-bad')

    if (mode === 'select') {
      messageEl.textContent = t.selectPrompt
      return
    }

    const productKey = getProductKey()

    if (!productKey) {
      messageEl.classList.remove('is-ok')
      messageEl.classList.add('is-bad')
      messageEl.textContent = t.keyMissing
      return
    }

    messageEl.textContent = ok ? t.ok(make, model) : t.bad(make, model)
  }

  const makes = Object.keys(db || {})
  setOptions(makeSelect, makes, t.makeLabel)
  setOptions(modelSelect, [], t.modelLabelFirst)
  modelSelect.disabled = true
  setMessage({ mode: 'hide' })

  makeSelect.addEventListener('change', () => {
    const make = makeSelect.value
    const models = make && db[make] ? Object.keys(db[make]) : []
    modelSelect.disabled = !make
    setOptions(modelSelect, models, t.modelLabel)
    setMessage({ mode: 'hide' })
  })

  modelSelect.addEventListener('change', () => {
    const make = makeSelect.value
    const model = modelSelect.value
    const keys = (db?.[make]?.[model]) || []
    const productKey = getProductKey()
    const ok = !!productKey && keys.includes(productKey)
    setMessage({ ok, make, model, mode: 'result' })
  })

  document.addEventListener('change', (e) => {
    if (!e.target || e.target.name !== 'id') return

    const make = makeSelect.value
    const model = modelSelect.value
    if (!make || !model) return

    const keys = (db?.[make]?.[model]) || []
    const productKey = getProductKey()
    const ok = !!productKey && keys.includes(productKey)
    setMessage({ ok, make, model, mode: 'result' })
  })
})()